import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useNavigate, useParams } from "react-router";
import {
    Table,
    Form,
    Accordion,
    Button,
    FloatingLabel,
    Alert,
} from "react-bootstrap";

import DeleteIcon from "../../../../assets/img/Delete.png";

import ContextComponent from "../../../AppContext";
import Utils from "../../../Utils";

const EditSitePage = () => {
    const navigate = useNavigate();
    const { siteid } = useParams();
    const projectPath = useParams();
    const projectId = projectPath["projectid"];
    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
    let [canRender, setCanRnder] = useState(false);
    const location = useLocation();
    const [originalQuizValue, setOriginalQuizValue] = useState(false);

    let [siteInfo, setSiteInfo] = useState({
        name: "",
        description: "",
        sme: "",
        siteBGColor: "",
        startButtonColor: "",
        startButtonTextColor: "",
        classicview: false,
        image0text: "",
        image0: "",
        image0jpg: "",
        image40text: "",
        image40: "",
        image40jpg: "",
        image70text: "",
        image70: "",
        image70jpg: "",
        showreportimage: false,
        secondaryLogo: "",
        enableNewReport: false,
        pointsSystem: false,
        pointRanges: [],
        nameReverseOrder: false,
        quiz: false,
        updatedView: false,
    });

    // let [imgDataArray, setImgDataArray] = useState(["", "", ""]);
    const onChangeImage = async (e) => {
        let file = e.currentTarget.files[0];
        let targetImage = e.currentTarget.attributes["imgname"].value;
        // let targetIndex = parseInt(
        //     e.currentTarget.attributes["imgindex"].value,
        //     10,
        // );
        document
            .querySelector(".indi-add-img-wrapper-" + targetImage)
            .classList.add("d-none");
        let imgPreviewEle = document.querySelector(
            ".indi-add-img-wrapper-preview-" + targetImage,
        );
        imgPreviewEle.classList.remove("d-none");
        await Utils.fileToDataUri(file).then((dataUri) => {
            imgPreviewEle.src = dataUri;
            let imgObj = {};
            imgObj[targetImage] = dataUri;
            let updatedSiteInfo = { ...siteInfo, ...imgObj };
            setSiteInfo(updatedSiteInfo);
            imgPreviewEle.src = dataUri;
        });
    };

    let [showAlert, setShowAlert] = useState(false);
    let [formValidateErrorMessage, setFormValidateErrorMessage] = useState("");

    const siteNameHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            name: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteDescriptionHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            description: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteSMEHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            sme: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteBGColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            siteBGColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle1 = document.getElementById("siteBG-Color1");
        logoEle1.value = val;
    };

    const siteBGInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            siteBGColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle = document.getElementById("siteBG-Color");
        logoEle.value = val;
    };

    const siteStartButtonColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            startButtonColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle1 = document.getElementById("startButtonColor1");
        logoEle1.value = val;
    };

    const siteStartButtonInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            startButtonColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle = document.getElementById("startButtonColor");
        logoEle.value = val;
    };

    const siteStartButtonTextColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            startButtonTextColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle1 = document.getElementById("startButtonTextColor1");
        logoEle1.value = val;
    };

    const siteStartButtonTextInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            startButtonTextColor: e.currentTarget.value,
        };
        setSiteInfo(updatedSiteInfo);
        let logoEle = document.getElementById("startButtonTextColor");
        logoEle.value = val;
    };

    const siteClassicviewHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            classicview: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteShowReportImageHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            showreportimage: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteEnableNewReportHandler = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            enableNewReport: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteEnablePointsSystem = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            pointsSystem: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    }

    const siteNameReverseOrder = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            nameReverseOrder: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    }

    const siteEnableQuiz = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            quiz: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const siteEnableUpdatedView = (e) => {
        let updatedSiteInfo = {
            ...siteInfo,
            updatedView: e.currentTarget.checked,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const Image0textHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            image0text: val,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const Image40textHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            image40text: val,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const Image70textHandler = (e) => {
        let val = e.currentTarget.value;
        let updatedSiteInfo = {
            ...siteInfo,
            image70text: val,
        };
        setSiteInfo(updatedSiteInfo);
    };

    const convertAbsolutePathToRelativePath = (imgPath) => {
        // Check if it contains the domain
        let domain = Utils.getDomainName();
        if (imgPath.includes(domain)) {
            // Replace the domain with an empty string
            return imgPath.replace(domain, '');
        }

        return imgPath;
    }

    const onSaveSite = (e) => {
      const updatedPointRanges = siteInfo?.pointRanges?.map((range) => ({
        ...range,
        imageJPG: convertAbsolutePathToRelativePath(range.imageJPG),
        imagePNG: convertAbsolutePathToRelativePath(range.imagePNG),
      }));

      let finalSiteInfo = {
        ...siteInfo,
        image0: convertAbsolutePathToRelativePath(siteInfo.image0),
        image0jpg: convertAbsolutePathToRelativePath(siteInfo.image0jpg),
        image40: convertAbsolutePathToRelativePath(siteInfo.image40),
        image40jpg: convertAbsolutePathToRelativePath(siteInfo.image40jpg),
        image70: convertAbsolutePathToRelativePath(siteInfo.image70),
        image70jpg: convertAbsolutePathToRelativePath(siteInfo.image70jpg),
        secondaryLogo: convertAbsolutePathToRelativePath(
          siteInfo.secondaryLogo,
        ),
        // updated pointRanges included here
        pointRanges: updatedPointRanges,
      };

      // New Interface and Updated View cannot be enabled together
      if (finalSiteInfo.classicview && finalSiteInfo.updatedView) {
        setAlert({
          show: true,
          message:
            "Please disable the New Interface before enabling the Updated View.",
          type: "danger",
        });

        return false;
      }

      if (validateForm(finalSiteInfo)) {
        submitSiteForm(finalSiteInfo);
      }
      return false;
    };;

    const validateForm = (formData) => {
        let errMsg = [];
        // console.log("formData::::", formData);
        if (formData.name.trim().length === 0) {
            errMsg.push("Site name is required");
        }
        if (formData.name.trim().length !== 0 && formData.name.trim().toLowerCase() === Utils.ADMIN_PAGE_ROUTING_VARIABLE) {
            let alertMessage = formData.name + " is a keyword can't be used as siteName";
            errMsg.push(alertMessage);
        }
        if (formData.sme.trim().length === 0) {
            errMsg.push("SME is required");
        }
        // if (formData.backgroundImage.trim().length === 0) {
        //     errMsg.push("Template background image is required");
        // }
        // if (formData.logoImage.trim().length === 0) {
        //     errMsg.push("Template logo image is required");
        // }
        // Need to validate the Points system data.
        const seenNames = new Set();

        (formData?.pointRanges || []).forEach((range, index) => {
            const rawName = range.name;
            const trimmedName = rawName?.trim().toLowerCase();

            // Rule 1: Name must not be empty
            if (!trimmedName) {
                errMsg.push(`Points range at index ${index} has an empty name. Name is required.`);
                return;
            }

            // Rule 2: Name must be unique
            if (seenNames.has(trimmedName)) {
                errMsg.push(`Duplicate name found in points Range at index ${index}: "${rawName}"`);
            } else {
                seenNames.add(trimmedName);
            }
        });

        if (errMsg.length) {
            setShowAlert(true);
            setFormValidateErrorMessage(errMsg.join(", "));
            return false;
        } else {
            setShowAlert(false);
            setFormValidateErrorMessage("");
            return true;
        }
    };

    const submitSiteForm = (siteInfo) => {
        setLoadingState({
            applyMask: true,
            text: "Updating the site",
        });
        const success = (res) => {
            setLoadingState({
                applyMask: false
            });
            if (location.pathname === Utils.APP_URLS.EDIT_SITE_PAGE.replace(":siteid", siteid)) {
                navigate(Utils.APP_URLS.SITES_PAGE);
            } else if (location.pathname === Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE.replace(":projectid", projectId).replace(":siteid", siteid)) {
                navigate(Utils.APP_URLS.PROJECTS_PAGE + `/${projectId}`);
            }

            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Site updated successfully!",
            });
        };
        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            console.log(err);
            if (location.pathname === Utils.APP_URLS.EDIT_SITE_PAGE.replace(":siteid", siteid)) {
                navigate(Utils.APP_URLS.SITES_PAGE);
            } else if (location.pathname === Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE.replace(":projectid", projectId).replace(":siteid", siteid)) {
                navigate(Utils.APP_URLS.PROJECTS_PAGE + `/${projectId}`);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Site update failed",
                type: "danger"

            });
        };

        try {
            Utils.updateSite(siteid, siteInfo).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    };

    const navigateToSitesPage = (e) => {
        if (location.pathname === Utils.APP_URLS.EDIT_SITE_PAGE.replace(":siteid", siteid)) {
            navigate(Utils.APP_URLS.SITES_PAGE);
        } else if (location.pathname === Utils.APP_URLS.PROJECT_EDIT_SITE_PAGE.replace(":projectid", projectId).replace(":siteid", siteid)) {
            navigate(Utils.APP_URLS.PROJECTS_PAGE + `/${projectId}`);
        }
    };

    const convertImageUrlToAbsolutePath = (imgPath) => {
        let absImagPath = Utils.getImagePath(imgPath)
        // console.log("absImagPath:::", absImagPath);
        return absImagPath;
    }

    const siteFetchByIdSuccess = (res) => {
        setLoadingState({
            applyMask: false,
        });
        // console.log(res.data);
        // Update siteInfo state with values from res.data
        const resData = res?.data;
        setOriginalQuizValue(resData?.quiz);
        setSiteInfo(prevState => ({
            ...prevState,
            name: resData?.name || "",
            description: resData?.description || "",
            sme: resData?.sme || "",
            siteBGColor: resData?.siteBGColor || "",
            startButtonColor: resData?.startButtonColor || "",
            startButtonTextColor: resData?.startButtonTextColor || "",
            classicview: resData?.classicview || false,
            image0text: resData?.image0text || "",
            image0: resData?.image0 ? convertImageUrlToAbsolutePath(resData.image0) : "",
            image0jpg: resData?.image0jpg ? convertImageUrlToAbsolutePath(resData.image0jpg) : "",
            image40text: resData?.image40text || "",
            image40: resData?.image40 ? convertImageUrlToAbsolutePath(resData.image40) : "",
            image40jpg: resData?.image40jpg ? convertImageUrlToAbsolutePath(resData.image40jpg) : "",
            image70text: resData?.image70text || "",
            image70: resData?.image70 ? convertImageUrlToAbsolutePath(resData.image70) : "",
            image70jpg: resData?.image70jpg ? convertImageUrlToAbsolutePath(resData.image70jpg) : "",
            showreportimage: resData?.showreportimage || false,
            secondaryLogo: resData?.secondaryLogo ? convertImageUrlToAbsolutePath(resData.secondaryLogo) : "",
            enableNewReport: resData?.enableNewReport || false,
            pointsSystem: resData?.pointsSystem || false,
            pointRanges: (resData?.pointRanges || []).map(range => ({
                name: range?.name || "",
                minValue: range?.minValue || 0,
                maxValue: range?.maxValue || 0,
                imageJPG: range?.imageJPG ? convertImageUrlToAbsolutePath(range.imageJPG) : "",
                imagePNG: range?.imagePNG ? convertImageUrlToAbsolutePath(range.imagePNG) : ""
            })),
            nameReverseOrder: resData?.nameReverseOrder || false,
            quiz: resData?.quiz || false,
            updatedView: resData?.updatedView || false,
        }));
        setCanRnder(true);
        // SetSiteBGColor(resData?.siteBGColor || "");
        // SetSiteStartButtonColor(resData?.startButtonColor || "");
        // SetSiteStartButtonTextColor(resData?.startButtonTextColor || "");
    };
    const siteFetchByIdFail = (err) => {
        setLoadingState({
            applyMask: false,
        });
        err?.message?.length && console.log(err);
        // setErrorMessage(error);
        if (err?.redirect) {
            setCanRedirectToLogin(true);
        }
    };

    useEffect(() => {
        setLoadingState({
            applyMask: true
        });
        Utils.getSiteDetailsbyId(siteid).then(
            siteFetchByIdSuccess,
            siteFetchByIdFail,
        );
    }, []);

    const addPointsRow = () => {
        const newRange = {
            name: "",
            minValue: 0,
            maxValue: 0,
            imageJPG: "",
            imagePNG: ""
        };

        setSiteInfo(prev => ({
            ...prev,
            pointRanges: [...prev.pointRanges, newRange]
        }));
    };

    const handlePointRangeChange = (index, field, value) => {
        const updatedRanges = [...siteInfo?.pointRanges];
        updatedRanges[index][field] = value;
        setSiteInfo(prev => ({
            ...prev,
            pointRanges: updatedRanges
        }));
    };

    const removePointRange = (index) => {
        const updated = siteInfo.pointRanges.filter((_, i) => i !== index);
        setSiteInfo(prev => ({
            ...prev,
            pointRanges: updated
        }));
    };

    const handlePointsImageUpload = async (e, index, field) => {
        const file = e.target.files[0];
        if (!file) return;
        const dataUri = await Utils.fileToDataUri(file);
        handlePointRangeChange(index, field, dataUri);
    };

    return (
        <>
            {canRender && (
                <form className="indi-add-template-form indi-edit-site-page">
                    <div>
                        <div className="indi-body-title">Edit Site</div>
                        {showAlert && (
                            <Alert className="indi-status-message in" variant="danger">
                                {formValidateErrorMessage}
                            </Alert>
                        )}
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Site name">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="name"
                                    placeholder="Enter site name"
                                    autoComplete="off"
                                    onChange={siteNameHandler}
                                    defaultValue={siteInfo.name}
                                />
                            </FloatingLabel>
                            <div className="indi-right-button-wrapper">
                                <Button onClick={onSaveSite}>Update</Button>
                                <Button onClick={navigateToSitesPage}>Cancel</Button>
                            </div>
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Description">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="description"
                                    placeholder="Enter Site Description"
                                    autoComplete="off"
                                    onChange={siteDescriptionHandler}
                                    defaultValue={siteInfo.description}
                                />
                            </FloatingLabel>
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="SME">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field"
                                    id="sme"
                                    placeholder="Enter SME value"
                                    autoComplete="off"
                                    onChange={siteSMEHandler}
                                    defaultValue={siteInfo.sme}
                                />
                            </FloatingLabel>
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Site BG Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field non-editable-color-text-field"
                                    id="siteBG-Color"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteBGColorHandler}
                                    defaultValue={siteInfo.siteBGColor}
                                    readOnly
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="siteBG-Color1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteBGInputColorHandler}
                                defaultValue={siteInfo.siteBGColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Start Button Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field non-editable-color-text-field"
                                    id="startButtonColor"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteStartButtonColorHandler}
                                    defaultValue={siteInfo.startButtonColor}
                                    readOnly
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="startButtonColor1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteStartButtonInputColorHandler}
                                defaultValue={siteInfo.startButtonColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <FloatingLabel label="Start Button Text Color">
                                <Form.Control
                                    type="text"
                                    className="indi-input-field non-editable-color-text-field"
                                    id="startButtonTextColor"
                                    placeholder=""
                                    autoComplete="off"
                                    onChange={siteStartButtonTextColorHandler}
                                    defaultValue={siteInfo.startButtonTextColor}
                                    readOnly
                                />
                            </FloatingLabel>
                            <Form.Control
                                type="color"
                                className="indi-input-field indi-color-input-field"
                                id="startButtonTextColor1"
                                placeholder=""
                                autoComplete="off"
                                onChange={siteStartButtonTextInputColorHandler}
                                defaultValue={siteInfo.startButtonTextColor}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="classicview"
                                    checked={siteInfo.classicview}
                                    label="New Interface"
                                    onChange={siteClassicviewHandler}
                                />
                            </div>
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="showreportimage"
                                    checked={siteInfo.showreportimage}
                                    label="Enable Spider Web"
                                    onChange={siteShowReportImageHandler}
                                />
                            </div>
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="enablenewreport"
                                    checked={siteInfo.enableNewReport}
                                    label="Enable New Report"
                                    onChange={siteEnableNewReportHandler}
                                />
                            </div>
                        </div>
                        <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="pointssystem"
                                    checked={siteInfo?.pointsSystem}
                                    label="Enable Points System"
                                    onChange={siteEnablePointsSystem}
                                />
                            </div>
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="namereverseorder"
                                    checked={siteInfo?.nameReverseOrder}
                                    label="Enable Name In Reverse Order"
                                    onChange={siteNameReverseOrder}
                                />
                            </div>
                            <div className="indi-add-form-item-input col">
                                <Form.Check
                                    type="switch"
                                    className="indi-input-switch-field"
                                    id="enablequiz"
                                    checked={siteInfo?.quiz}
                                    label="Enable Quiz"
                                    disabled={originalQuizValue}
                                    onChange={siteEnableQuiz}
                                />
                            </div>
                        </div>
                        <div className="indi-data-table-wrapper col">
                            <Form.Check
                                type="switch"
                                className="indi-input-switch-field"
                                id="enableupdatedview"
                                checked={siteInfo?.updatedView}
                                label="Enable Updated View"
                                onChange={siteEnableUpdatedView}
                            />
                        </div>
                        <div className="indi-data-table-wrapper d-flex row">
                            <div className="indi-add-form-item-input col">
                                <label htmlFor="iconImage" className="form-label">Secondary Logo Image:</label>
                                <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                    <input
                                        type="file"
                                        imgname="secondaryLogo"
                                        id="secondaryLogo"
                                        imgindex={6}
                                        className="indi-upload-picture-file-input"
                                        onChange={onChangeImage}
                                    />
                                    <div className="indi-add-img-wrapper"></div>
                                </div>
                            </div>
                            <div className="indi-add-form-item-input col">
                                <div className="indi-add-img-wrapper-secondaryLogo d-none">no preview</div>
                                <img
                                    src={siteInfo.secondaryLogo}
                                    alt="background"
                                    className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-secondaryLogo"
                                />
                            </div>
                        </div>
                        <Accordion className="indi-data-table-wrapper" defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>Image uploads</Accordion.Header>
                                <Accordion.Body>
                                    <Table responsive="sm">
                                        <thead className="indi-data-table-header">
                                            <tr>
                                                {/* <th>Image place</th> */}
                                                <th className="text-center">Image Text</th>
                                                <th className="text-center">Upload</th>
                                                <th className="text-center">Preview</th>
                                                <th className="text-center">JPEG-Upload</th>
                                                <th className="text-center">JPEG-Preview</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-site-image0-name">
                                                    Image0
                                                </td> */}
                                                <td className="indi-data-table-td-image0-name text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image0 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image0text"
                                                                placeholder="Enter Image0 text"
                                                                autoComplete="off"
                                                                onChange={Image0textHandler}
                                                                defaultValue={siteInfo.image0text}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={0}
                                                            imgname="image0"
                                                            id="image0"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image0 d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image0}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image0"
                                                    />
                                                </td>
                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={3}
                                                            imgname="image0jpg"
                                                            id="image0jpg"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image0jpg d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image0jpg}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image0jpg"
                                                    />
                                                </td>
                                            </tr>

                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-site-image40-name">
                                                    Image40
                                                </td> */}
                                                <td className="indi-data-table-td-image40-name text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image40 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image40text"
                                                                placeholder="Enter Image40 text"
                                                                autoComplete="off"
                                                                onChange={Image40textHandler}
                                                                defaultValue={siteInfo.image40text}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={1}
                                                            imgname="image40"
                                                            id="image40"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image40 d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image40}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image40"
                                                    />
                                                </td>
                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={4}
                                                            imgname="image40jpg"
                                                            id="image40jpg"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image40jpg d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image40jpg}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image40jpg"
                                                    />
                                                </td>
                                            </tr>

                                            <tr className="indi-data-table-tr">
                                                {/* <td className="indi-data-table-td-image70-name">
                                                    Image70
                                                </td> */}
                                                <td className="indi-data-table-td-user-email text-center">
                                                    <div className="indi-data-table-wrapper d-flex indi-text-btn-row">
                                                        <FloatingLabel label="Image70 text">
                                                            <Form.Control
                                                                type="text"
                                                                className="indi-input-field"
                                                                id="Image70text"
                                                                placeholder="Enter Image70 text"
                                                                autoComplete="off"
                                                                onChange={Image70textHandler}
                                                                defaultValue={siteInfo.image70text}
                                                            />
                                                        </FloatingLabel>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={2}
                                                            imgname="image70"
                                                            id="image70"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>

                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image70 d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image70}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image70"
                                                    />
                                                </td>
                                                <td className="indi-data-table-td-template-image text-center">
                                                    <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                        <input
                                                            type="file"
                                                            imgindex={5}
                                                            imgname="image70jpg"
                                                            id="image70jpg"
                                                            className="indi-upload-picture-file-input"
                                                            onChange={onChangeImage}
                                                        />
                                                        <div className="indi-add-img-wrapper"></div>
                                                    </div>
                                                </td>
                                                <td className="indi-data-table-td-template-img-preview text-center">
                                                    <div className="indi-add-img-wrapper-image70jpg d-none">no preview</div>
                                                    <img
                                                        src={siteInfo.image70jpg}
                                                        alt="background"
                                                        className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-image70jpg"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        {siteInfo?.pointsSystem &&
                            <Accordion className="indi-data-table-wrapper" defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Points Range</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="indi-add-key-value-item d-flex flex-column">
                                            <Table responsive="sm">
                                                <thead className="indi-data-table-header">
                                                    <tr>
                                                        <th className="text-center">Name</th>
                                                        <th className="text-center">Min Value</th>
                                                        <th className="text-center">Max Value</th>
                                                        <th className="text-center">JPEG-Upload</th>
                                                        <th className="text-center">JPEG-Preview</th>
                                                        <th className="text-center">PNG-Upload</th>
                                                        <th className="text-center">PNG-Preview</th>
                                                        <th className="text-center">Delete</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {siteInfo?.pointRanges?.map((range, index) => (
                                                        <tr key={index} className="indi-data-table1-tr">
                                                            <td className="indi-data-table-td-range-name text-center">
                                                                <div className="indi-data-table-wrapper d-flex">
                                                                    <FloatingLabel label="Name">
                                                                        <Form.Control
                                                                            type="text"
                                                                            className="indi-input-field"
                                                                            placeholder="Enter name"
                                                                            autoComplete="off"
                                                                            value={range?.name}
                                                                            onChange={(e) =>
                                                                                handlePointRangeChange(index, 'name', e.target.value)
                                                                            }
                                                                        />
                                                                    </FloatingLabel>
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-range-min-value text-center">
                                                                <div className="indi-data-table-wrapper d-flex">
                                                                    <FloatingLabel label="Min">
                                                                        <Form.Control
                                                                            type="number"
                                                                            className="indi-input-field"
                                                                            placeholder="Enter Min Value"
                                                                            autoComplete="off"
                                                                            value={range?.minValue}
                                                                            onChange={(e) =>
                                                                                handlePointRangeChange(index, 'minValue', parseInt(e.target.value) || 0)
                                                                            }
                                                                        />
                                                                    </FloatingLabel>
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-range-max-value text-center">
                                                                <div className="indi-data-table-wrapper d-flex">
                                                                    <FloatingLabel label="Max">
                                                                        <Form.Control
                                                                            type="number"
                                                                            className="indi-input-field"
                                                                            placeholder="Enter Max Value"
                                                                            autoComplete="off"
                                                                            value={range?.maxValue}
                                                                            onChange={(e) =>
                                                                                handlePointRangeChange(index, 'maxValue', parseInt(e.target.value) || 0)
                                                                            }
                                                                        />
                                                                    </FloatingLabel>
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-template-image text-center">
                                                                <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                                    <input
                                                                        type="file"
                                                                        accept="image/jpeg"
                                                                        className="indi-upload-picture-file-input"
                                                                        onChange={(e) => handlePointsImageUpload(e, index, 'imageJPG')}
                                                                    />
                                                                    <div className="indi-add-img-wrapper"></div>
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-template-img-preview text-center">
                                                                {range?.imageJPG ? <img
                                                                    src={range?.imageJPG}
                                                                    alt="background"
                                                                    className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-points-imageJPG"
                                                                /> : <div className="indi-add-img-wrapper-points-imageJPG">no preview</div>}
                                                            </td>
                                                            <td className="indi-data-table-td-template-image text-center">
                                                                <div className="indi-add-form-item-input indi-upload-picture-file-input-wrapper">
                                                                    <input
                                                                        type="file"
                                                                        accept="image/png"
                                                                        className="indi-upload-picture-file-input"
                                                                        onChange={(e) => handlePointsImageUpload(e, index, 'imagePNG')}
                                                                    />
                                                                    <div className="indi-add-img-wrapper"></div>
                                                                </div>
                                                            </td>
                                                            <td className="indi-data-table-td-template-img-preview text-center">
                                                                {range?.imagePNG ? <img
                                                                    src={range?.imagePNG}
                                                                    alt="background"
                                                                    className="indi-add-img-wrapper-preview indi-add-img-wrapper-preview-points-imagePNG"
                                                                /> : <div className="indi-add-img-wrapper-points-imagePNG">no preview</div>}
                                                            </td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <img
                                                                        className="indi-add-question-delete-icon-img"
                                                                        src={DeleteIcon}
                                                                        alt="delete"
                                                                        onClick={() => removePointRange(index)}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                            <div className="w-100">
                                                <Button
                                                    onClick={addPointsRow}
                                                    className="float-end"
                                                    // size="sm"
                                                    style={{ fontSize: '0.7rem', padding: '0.2rem 0.5rem' }}
                                                >
                                                    Add Row
                                                </Button>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        }
                    </div>
                </form>
            )}
        </>
    );
};

export default EditSitePage;